@if (totalPages() > 1 && withControls()) {
    <div class="carousel-controls">
        <button class="carousel-controls__button" aria-label="Previous" type="button" (click)="prevSlide()">
            <mat-icon svgIcon="ico_arrow_left"></mat-icon>
        </button>
        <div class="carousel-indicator">
            <p class="h2">{{ currentPage() }}</p>
            <p class="body-0">/</p>
            <p class="h2">{{ totalPages() }}</p>
        </div>
        <button class="carousel-controls__button" aria-label="Next" type="button" (click)="nextSlide()">
            <mat-icon svgIcon="ico_arrow_right"></mat-icon>
        </button>
    </div>
}

<div class="carousel swiper" #swiperContainer>
    <div class="swiper-wrapper">
        @for (p of products(); track $index) {
            <div class="swiper-slide">
                <div class="product-slide">
                    <!-- RCP-441: wishlist disabled — removed binding: (toggleWishlist)="toggleWishList($event)" -->
                    <lib-product-list-card
                        class="products-card"
                        [product]="p"
                        (addToCart)="addToCart($event)"
                        (clickOnProduct)="onShowProduct($event)"
                        (focusin)="onFocus($index)"
                        (hoverOnAction)="onHoverOnAction($event)"
                    ></lib-product-list-card>
                </div>
            </div>
        }
    </div>
</div>
